import React from 'react';
import Map from '../map/Map';
import Header from "../header/Header";
import Footer from "../footer/Footer";
import MapInfoSection from "./LegendInfo";

const HeroSection = () => {
    return (<section className="hero-section"
                     style={{background: "url('/images/dreamstime.jpg') no-repeat center center / cover"}}>
        {/* Background image is set via CSS */}
        <div className="hero-overlay">
            <div className="hero-logo">
                <img src="/images/esae-map-logo-2.png" alt="Rare Diseases Greece Logo"/>
            </div>
            <div className="hero-buttons">
                <button className="hero-button" onClick={() => window.location.href = '/register'}><b>ΕΓΓΡΑΦΕΙΤΕ</b>
                </button>
                <button className="hero-button" onClick={() => window.location.href = '/login'}><b>ΣΥΝΔΕΘΕΙΤΕ</b>
                </button>
            </div>
        </div>
    </section>);
};

const Home = () => {
    return (<div>
        <Header/>
        <HeroSection/>
        {/*<WhatWeDo/>*/}
        <MapInfoSection/>
        <Map/>
        <section className="cta-section">
            <div className="cta-left">
                <h3>Συμβάλλετε στη Συγκέντρωση της Πληροφορίας</h3>
                <button className="cta-button" onClick={() => window.location.href = '/more'}>Περισσότερα</button>
            </div>
            <div className="cta-right">
                <img src="/images/puzzle.jpg" alt=""/>
            </div>
        </section>
        <Footer/>
    </div>);
}

export default Home;
